import React, { useRef, useEffect } from 'react';
import { Button } from 'antd';
import { Html } from '@react-three/drei';
import { STUDIO_ID_SUFFIX } from '../../../../util/constants';
import type { Asset } from './sceneAsset';

type SpherePositionPointAssetProps = {
  asset: Asset;
  position?: THREE.Vector3;
  scale?: THREE.Vector3;
  rotation?: THREE.Euler;
  instanceId: string;
};

export default function SpherePositionPointAsset({
  asset,
  position,
  rotation,
  scale,
  instanceId,
}: SpherePositionPointAssetProps) {
  const ref = useRef<any>(null);
  function onSavePositionPoint() {
    window.dispatchEvent(
      new CustomEvent('save_action_position', {
        detail: {
          nodeId: asset.metadata?.nodeId,
          position: { ...ref?.current?.position },
          propertyKey: asset.metadata?.propertyKey,
          assetToDelete: { props: { asset } },
        },
      })
    );
  }

  useEffect(() => {
    if (ref.current) {
      asset.ref = ref;
    }
  }, []);

  return (
    <group
      ref={ref}
      key={`asset-${asset.name}-${instanceId}`}
      position={position ?? [0, 0, 0]}
      scale={scale ?? [1, 1, 1]}
      rotation={rotation}
      name={`${asset.name}${STUDIO_ID_SUFFIX}${instanceId}`}
    >
      {/* Sphere */}
      <mesh>
        <sphereGeometry args={[0.3, 32, 32]} />
        <meshStandardMaterial color='hotpink' />
      </mesh>

      {/* Label (e.g., using HTML) */}
      <Html
        position={[0, 1.5, 0]}
        center
        distanceFactor={10}
        style={{
          display: 'flex',
          width: 150,
          flexDirection: 'column',
          alignItems: 'center',
          background: 'rgba(255,255,255,0.9)',
          borderRadius: '4px',
          padding: '4px 6px',
          fontSize: '12px',
          color: '#000000',
        }}
      >
        <div>Position Point</div>
        <div>{`${asset.metadata?.actionName} - ${asset.metadata?.propertyName}`}</div>
        <Button
          style={{
            marginTop: 4,
            fontSize: '11px',
            padding: '2px 6px',
            borderRadius: '3px',
            cursor: 'pointer',
          }}
          type='primary'
          onClick={onSavePositionPoint}
        >
          Take Position
        </Button>
      </Html>
    </group>
  );
}
